import { ChangeEvent } from 'react';
import { Input as AntdInput, Space as AntdSpace, Image } from 'antd';
import styled from 'styled-components';
import { useProcBasicFormContext } from '@/entities/proc';

export const ImageUrl = () => {
  const {
    imageLink,
    setImageLink,
    setFileList,
    setUploadedImageLink,
    setUploadedFileKey,
  } = useProcBasicFormContext();

  const handleLinkChange = (e: ChangeEvent<HTMLInputElement>) => {
    setImageLink(e.target.value);
    setFileList([]);
    setUploadedFileKey('');
    setUploadedImageLink('');
  };

  return (
    <Space
      data-testid="image-url-input"
      direction="vertical"
      style={{ width: '100%', marginTop: 10 }}
    >
      <Input value={imageLink} onChange={handleLinkChange} />
      <Image src={imageLink} style={{ maxWidth: 200 }} />
    </Space>
  );
};

const Space = styled(AntdSpace)`
  .ant-space-item {
    width: 100%;
  }
`;

const Input = styled(AntdInput)``;
